import React, { useMemo } from "react";
import { TableListing } from "../../../../../components/AppListing/TableListing";
import { formatPhoneNumber } from "../../../../../utils/common_lib";
import ListIcon from "../../../../../components/listIcon";

function PracticeStaffListing({
  nurses = [],
  nursesLoading = false,
  onCheckInOut = () => {},
}) {

    const cols = useMemo(() => [
        {
            title: "Staff Name",
            key: "name",
            colClass: "flex text-left",
            getData: (item) => item?.User?.name || item?.User?.username || "-",
        },
        {
            title: "Username",
            key: "username",
            colClass: "flex text-left",
            getData: (item) => item?.User?.username || "-",
        },
        {
            title: "Email",
            key: "email",
            colClass: "flex text-left",
            getData: (item) => item?.User?.email || "-",
        },
        {
            title: "Mobile Number",
            key: "phone",
            colClass: "flex text-left",
            getData: (item) => item?.User?.phone || item?.User?.phonecell ? formatPhoneNumber(item?.User?.phone || item?.User?.phonecell ) : <p className="px-6">-</p>,
        },
        {
            title: "Actions",
            key: "actions",
            colClass: "flex text-center justify-center items-center",
            align: "center",
            skipColHtmlTooltip: true,
            getData: (item) => {
                return (
                    <div className="flex gap-2 items-center justify-center h-[100%]">

                        <ListIcon
                            title="Check-in/Check-out"
                            handler={() => onCheckInOut(item)}
                            type="check-in"
                        />

                    </div>
                );
            },
        },
    ], [onCheckInOut]);

    return (
        <div className="px-3 mt-2 w-full h-[calc(100vh-130px)] overflow-y-auto shadow-md">
            <TableListing
                listData={nurses || []}
                cols={cols || []}
                loading={nursesLoading || false}
            />
        </div>
    );
}

export default PracticeStaffListing;
